import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import {
  NgxMaskConfig,
  NgxMaskDirective,
  NgxMaskPipe,
  provideNgxMask,
} from 'ngx-mask';
import { PrAliveComponent } from './pr-alive/pr-alive.component';
import { PrBreadcrumbModule } from './pr-breadcrumb/pr-breadcrumb.module';
import { PrButtonAddModule } from './pr-button/pr-button-add/pr-button-add.module';
import { PrButtonConfirmModule } from './pr-button/pr-button-confirmation/pr-button-confirm.module';
import { PrButtonDropdownModule } from './pr-button/pr-button-dropdown/pr-button-dropdown.module';
import { PrButtonToggleModule } from './pr-button/pr-button-toggle/pr-button-toggle.module';
import { PrButtonModule } from './pr-button/pr-button/pr-button.module';
import { PrToolbarModule } from './pr-button/pr-toolbar/pr-toolbar.module';
import { PrCardModule } from './pr-card/pr-card.module';
import { PrColorPanelComponent } from './pr-color-panel/pr-color-panel.component';
import { PrComparaisonModule } from './pr-comparaison/pr-comparaison.module';
import { PrFileModule } from './pr-file/pr-file.module';
import { PrGedDocumentCardModule } from './pr-ged-document/ged-document-card.module';
// import { PrCheckboxGroupModule } from "./pr-form/pr-checkbox-group/pr-checkbox-group.module";
import { BsDropdownConfig, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { IconSpriteModule } from './icon-sprite/icon-sprite.module';
import { ToastModule } from './notification/toast.module';
import { PrButtonSwitchModule } from './pr-button/pr-button-switch/pr-button-switch.module';
import { PrComparaisonV2Module } from './pr-comparaison-v2/pr-comparaison-v2.module';
import { PrDangerLadderModule } from './pr-danger-ladder/pr-danger-ladder.module';
import { PrExpansionPanelModule } from './pr-expansion-panel/pr-expansion-panel.module';
import { PrFormModule } from './pr-form/pr-form.module';
import { PrIconModule } from './pr-icon/pr-icon.module';
import { PrImageViewerModule } from './pr-image-viewer/pr-image-viewer.module';
import { PrLabelModule } from './pr-label/pr-label.module';
import { PrListModule } from './pr-list/pr-list.module';
import { PrLoaderModule } from './pr-loader/pr-loader.module';
import { PrMapModule } from './pr-map/pr-map.module';
import { PrModalModule } from './pr-modal/pr-modal.module';
import { PrNotificationModule } from './pr-notification/pr-notification.module';
import { PrPageModule } from './pr-page/pr-page.module';
import { PrPaginationV2Module } from './pr-pagination-v2/pr-pagination-v2.module';
import { PrPanelModule } from './pr-panel/pr-panel.module';
import { PrProgressModule } from './pr-progress/pr-progress.module';
import { PrProjectProgressModule } from './pr-project-progress/pr-project-progress.module';
import { PrQuestionModule } from './pr-question/pr-question.module';
import { PrRadioModule } from './pr-radio/pr-radio.module';
import { PrRiskLevelLadderModule } from './pr-risk-level-ladder/pr-risk-level-ladder.module';
import { PrSearchInputModule } from './pr-search-input/pr-search-input.module';
import { PrSelectSearchModule } from './pr-select-search/pr-select-search.module';
import { PrSelectModule } from './pr-select/pr-select.module';
import { PrSidepanelModule } from './pr-sidepanel/pr-sidepanel.module';
import { PrSumModule } from './pr-sum/pr-sum.module';
import { PrSwiperModule } from './pr-swiper/pr-swiper.module';
import { PrTabModule } from './pr-tab/pr-tab.module';
import { PrTableModule } from './pr-table/pr-table.module';
import { PrThemeSwitchModule } from './pr-theme-switch/pr-theme-switch.module';
import { PrTooltipIconModule } from './pr-tooltip-icon/pr-tooltip-icon.module';
import { PrValueModule } from './pr-value/pr-value.module';

export const options: Partial<NgxMaskConfig> | (() => Partial<NgxMaskConfig>) = null;

@NgModule({
  declarations: [PrAliveComponent, PrColorPanelComponent],
  imports: [
    CommonModule,
    NgxMaskDirective,
    NgxMaskPipe,
    PrBreadcrumbModule,
    PrButtonConfirmModule,
    PrButtonDropdownModule,
    PrButtonModule,
    PrButtonToggleModule,
    PrCardModule,
    PrFormModule,
    PrIconModule,
    PrLoaderModule,
    PrModalModule,
    PrNotificationModule,
    PrPageModule,
    PrPaginationV2Module,
    PrPanelModule,
    PrProgressModule,
    PrProgressModule,
    PrRadioModule,
    PrMapModule,
    PrSelectModule,
    PrSelectSearchModule,
    PrSidepanelModule,
    PrSumModule,
    PrSwiperModule,
    PrTableModule,
    PrToolbarModule,
    PrTooltipIconModule,
    PrLabelModule,
    PrValueModule,
    PrComparaisonModule,
    PrQuestionModule,
    PrTabModule,
    PrFileModule,
    PrGedDocumentCardModule,
    GoogleMapsModule,
    PrButtonAddModule,
    PrRiskLevelLadderModule,
    PrImageViewerModule,
    PrThemeSwitchModule,
    PrListModule,
    PrExpansionPanelModule,
    PrDangerLadderModule,
    IconSpriteModule,
    PrComparaisonV2Module,
    BsDropdownModule.forRoot(),
    PrProjectProgressModule,
  ],
  exports: [
    PrAliveComponent,
    PrBreadcrumbModule,
    PrButtonConfirmModule,
    PrButtonDropdownModule,
    PrButtonModule,
    PrModalModule,
    PrButtonToggleModule,
    PrButtonSwitchModule,
    PrCardModule,
    PrColorPanelComponent,
    PrFormModule,
    PrIconModule,
    PrLoaderModule,
    PrNotificationModule,
    PrPageModule,
    PrPaginationV2Module,
    PrPanelModule,
    PrProgressModule,
    PrProgressModule,
    PrRadioModule,
    PrMapModule,
    PrSelectModule,
    PrSelectSearchModule,
    PrSidepanelModule,
    PrSumModule,
    PrSwiperModule,
    PrTableModule,
    PrToolbarModule,
    PrTooltipIconModule,
    PrLabelModule,
    PrSearchInputModule,
    PrValueModule,
    PrComparaisonModule,
    PrQuestionModule,
    PrTabModule,
    PrFileModule,
    PrGedDocumentCardModule,
    BsDropdownModule,
    PrButtonAddModule,
    PrRiskLevelLadderModule,
    PrImageViewerModule,
    PrThemeSwitchModule,
    PrListModule,
    PrExpansionPanelModule,
    PrDangerLadderModule,
    ToastModule,
    IconSpriteModule,
    PrComparaisonV2Module,
    PrProjectProgressModule,
  ],
  providers: [provideNgxMask(), BsDropdownConfig],
})
export class ComponentsModule {}
